import { STATUS_SPECS } from '../actionTypes';

const initialState = {
  preserveStatus: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case STATUS_SPECS.SET_STATUS_DATA:
      return {
        ...state,
        preserveStatus: action.payload,
      };
    default:
      return state;
  }
};
